export const storeVariables = /* GraphQL */ `
  $seller_id: ID,
  $owner_id: ID
`
